import { render, staticRenderFns } from "./DropdownVerticalDotsButton.vue?vue&type=template&id=a3ff0388&scoped=true"
import script from "./DropdownVerticalDotsButton.vue?vue&type=script&lang=ts"
export * from "./DropdownVerticalDotsButton.vue?vue&type=script&lang=ts"
import style0 from "./DropdownVerticalDotsButton.vue?vue&type=style&index=0&id=a3ff0388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ff0388",
  null
  
)

export default component.exports